<div class="card">
  <div class="card-body">
    <h5 class="card-title">林業労働災害体験シミュレータ</h5>
    <h6 class="card-subtitle mb-2 text-muted">© 株式会社森林環境リアライズ</h6>
    <p class="card-text">
    </p>
    <dl class="row">
      <dt class="col-sm-3">制作年</dt>
      <dd class="col-sm-9">2018 - 2020</dd>
    
      <dt class="col-sm-3">プラットホーム</dt>
      <dd class="col-sm-9">HTV Vive (SteamVR) / Pico Neo 2</dd>
    </dl>
    <a href="https://www.f-realize.co.jp/vr/" class="btn btn-primary">製品情報</a>
  </div>
</div>
